import { render, staticRenderFns } from "./DemDetTariffPop.vue?vue&type=template&id=494548ba"
import script from "./DemDetTariffPop.vue?vue&type=script&lang=js"
export * from "./DemDetTariffPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('494548ba')) {
      api.createRecord('494548ba', component.options)
    } else {
      api.reload('494548ba', component.options)
    }
    module.hot.accept("./DemDetTariffPop.vue?vue&type=template&id=494548ba", function () {
      api.rerender('494548ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/popup/DemDetTariffPop.vue"
export default component.exports